import { Component, input } from '@angular/core';
import { TextField, JssModule } from '@core/jss-proxy';

import { LinkListComponent, ListLink } from '../link-list/link-list.component';

export type LinkList = {
  id: string;
  title: TextField;
  links: ListLink[];
};

@Component({
  selector: 'wl-link-list-section',
  standalone: true,
  templateUrl: './link-list-section.component.html',
  styleUrls: [
    './link-list-section.component.ed.scss',
    './link-list-section.component.essent.scss',
  ],
  imports: [JssModule, LinkListComponent],
})
export class LinkListSectionComponent {
  readonly title = input.required<TextField>();
  readonly linkLists = input.required<LinkList[]>();
}
